import React, { Fragment } from "react";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";

import Button from "@material-ui/core/Button";

import { SiteService } from "services/site/Site.service";
import { DrawerService } from "services/drawer/Drawer.service";

import { Application } from "models/application/Application";

import Dialog from "components/common/dialog/Dialog";

function DeployApplication({
  siteService,
  drawerService,
  application,
  action,
  t,
  drawerProps
}: {
  siteService: SiteService;
  drawerService: DrawerService;
  application: Application;
  action?: () => void;
  drawerProps?: any;
} & WithTranslation) {
  return (
    <Dialog
      close={() => drawerService.close(drawerProps.name)}
      render={({ close }) => (
        <Fragment>
          <div className="modal-header">
            <h5 className="modal-title">
              {t("application.deploy.title", {
                application
              })}
            </h5>
          </div>
          <div className="modal-footer">
            <Button
              color="secondary"
              variant="contained"
              className="p-2"
              size="small"
              onClick={close}
            >
              {t("application.deploy.cancelButton")}
            </Button>
            <Button
              color="primary"
              variant="contained"
              className="p-2"
              size="small"
              onClick={() =>
                siteService
                  .deployApplication({
                    application
                  })
                  .then(action)
                  .then(close)
              }
            >
              {t("application.deploy.deployButton")}
            </Button>
          </div>
        </Fragment>
      )}
    />
  );
}

export default wire(
  ["siteService", "drawerService"],
  withTranslation()(DeployApplication)
);
